<template lang="pug">
  .applications
    p.
      Entscheide Dich zeitnah, bei welchen Schichten Du arbeiten möchtest.
      Wenn der Schichtplan fertig ist, bekommst Du eine Mail.
    ul
      li.day(v-for="(day, index) in days", :class="{'gray': index % 2 === 0}")
        .date {{ day.date | moment('dd. Do MMM ')}}
        .events
          .event(v-for="event in day.events")
            dl
              dt {{ event.badge }}
              dd {{ event.start | moment('HH:mm') }} - {{ event.name }}
        .application(v-for="application in day.applications")
          application(:application="application")

</template>

<script>
export default {
  name: 'applications',
  data () {
    return {
      days: []
    }
  },
  methods: {
    applicationResponse: function (application, response) {
      let url = '/shift-preference/' + application.shift.id + '/0/' + response
      console.log(application.shift.event.name + ': ' + application.shift.shift_type)
      console.log(url)
      this.$http.get(url)
        .set({Authorization: 'jwt ' + this.$root.loginToken})
        .then(res => {
          this.days = res.body
        })
        .catch(err => {
          console.log(err)
          this.$notify.danger({content: 'Bewerbungsfehler'})
          console.log(err)
        })
    }
  },
  created () {
    // get applications
    this.$nextTick(function () {
      let loginToken = this.$root.getLoginToken()
      if (loginToken !== 'undefined') {
        this.$http.get('/applications/')
          .set({Authorization: 'jwt ' + loginToken})
          .then(res => {
            this.days = res.body
          })
          .catch(err => {
            console.log(err)
            this.$notify.danger({content: 'Bewerbungsfehler'})
            console.log(err)
          })
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">


li.day
  margin-left: -5px
  margin-right: -5px
  padding: 10px 5px 15px 5px
  margin-top: 2em
  background: rgba(44, 44, 44, 0.03)
  &.gray
    background: rgba(44, 44, 44, 0.2)

.date
  font-weight: bold
  font-size: 23px

dt, dd
  display: inline-block
  font-weight: bold
dt
  width: 100px

.events
  display: flex
  flex-direction: column

</style>



// WEBPACK FOOTER //
// Applications.vue?c7c1cffc